import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Header.css'; // Import the CSS file

const Header = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
  };

  const scrollToSection = (sectionId, e) => {
    e.preventDefault(); // Prevent default anchor behavior
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth',
        block: 'start'
      });
    }
    setIsNavCollapsed(true); // Close menu after clicking
  };

  return (
    <header className="header-background">
      <nav className="navbar navbar-expand-lg navbar-dark ">
        <div className="container-fluid">
          <a className="navbar-brand" href="#">Snow Kone Factory</a>
          <button 
            className="navbar-toggler" 
            type="button" 
            aria-controls="navbarNav" 
            aria-expanded={!isNavCollapsed}
            aria-label="Toggle navigation"
            onClick={handleNavCollapse}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div 
            className={`${isNavCollapsed ? 'collapse' : ''} navbar-collapse`} 
            id="navbarNav"
          >
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('about', e)} 
                  href="#about"
                >
                  About Us
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('flavors', e)} 
                  href="#flavors"
                >
                  Our Flavors
                </a>
              </li>
              <li className="nav-item">
                <a 
                  className="nav-link" 
                  onClick={(e) => scrollToSection('contact', e)} 
                  href="#contact"
                >
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <div className=' text-white text-center py-5'>
        <h1 className="elegant-font custom-header">Snow Kone Factory</h1>
        <p className="elegant-font custom-subheader">Cool down with our delicious snowcones!</p>
      </div>
      <img 
        src={process.env.PUBLIC_URL + '/images/snowconeFooter.jpg'} 
        alt="Footer" 
        className="footer-image" 
      />
    </header>
  );
};

export default Header;